import { APPLICATIONS_ID } from "@/constants";
import pixelchatJsonLd from "@/data/jsonLd.pixelchat.json";
import spicychatJsonLd from "@/data/jsonLd.spicychat.json";

export const getMetaDataForJsonLD = (applicationId: APPLICATIONS_ID): Record<string, unknown> | null => {
    switch (applicationId) {
      case APPLICATIONS_ID?.PixelChat:
        return pixelchatJsonLd;
      case APPLICATIONS_ID?.SpicyChat:
        return spicychatJsonLd;
      default:
        return null
    }
  };